import { render, staticRenderFns } from "./Jobs.vue?vue&type=template&id=52dc2af8"
import script from "./Jobs.vue?vue&type=script&lang=js"
export * from "./Jobs.vue?vue&type=script&lang=js"
import style0 from "./Jobs.vue?vue&type=style&index=0&id=52dc2af8&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports